import { render, staticRenderFns } from "./RiskAssessmentAssignedLevelHeader.vue?vue&type=template&id=580d4380&scoped=true&"
import script from "./RiskAssessmentAssignedLevelHeader.vue?vue&type=script&lang=ts&"
export * from "./RiskAssessmentAssignedLevelHeader.vue?vue&type=script&lang=ts&"
import style0 from "./RiskAssessmentAssignedLevelHeader.vue?vue&type=style&index=0&id=580d4380&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580d4380",
  null
  
)

export default component.exports